module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/vision_lv_mobile-b917fffc0f56e6614ac34b9e99410284.webp";